import { render, staticRenderFns } from "./BaseInputSelectWithFlagReadOnly.vue?vue&type=template&id=16f74a0b&scoped=true&"
import script from "./BaseInputSelectWithFlagReadOnly.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelectWithFlagReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputSelectWithFlagReadOnly.vue?vue&type=style&index=0&id=16f74a0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f74a0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
